import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { setPxParamVariable } from 'src/app/shared/utils/perimeterx';

import { getPerimeterXUserData } from './api';

export function useUpdatePerimeterXUserData(): () => Promise<void> {
	const utilityContext = useUtilityContext();

	return useCallback(
		async function updatePerimeterXUserData() {
			const config = await getPerimeterXUserData(utilityContext);
			setPxParamVariable('userId', config.userId ?? '');
			setPxParamVariable('emailDomain', config.emailDomain ?? '');
			setPxParamVariable('emailHash', config.emailHash ?? '');
			setPxParamVariable('accountDate', config.accountDate ?? '');
		},
		[utilityContext],
	);
}
